document.addEventListener('DOMContentLoaded', () => {
  const savedKey = 'nelora-saved-products';
  const getSaved = () => new Set(JSON.parse(localStorage.getItem(savedKey) || '[]'));
  const save = (saved) => localStorage.setItem(savedKey, JSON.stringify([...saved]));
  const saved = getSaved();

  document.querySelectorAll('[data-product-favorite]').forEach((button) => {
    const handle = button.dataset.productFavorite;
    const active = saved.has(handle);
    button.setAttribute('aria-pressed', active ? 'true' : 'false');
    button.setAttribute('aria-label', active ? 'Remove from saved items' : 'Save item');
    button.addEventListener('click', () => {
      const next = button.getAttribute('aria-pressed') !== 'true';
      if (next) saved.add(handle); else saved.delete(handle);
      save(saved);
      button.setAttribute('aria-pressed', next ? 'true' : 'false');
      button.setAttribute('aria-label', next ? 'Remove from saved items' : 'Save item');
    });
  });

  document.querySelectorAll('[data-header-menu]').forEach((menu) => {
    menu.addEventListener('toggle', () => {
      if (!menu.open) return;
      document.querySelectorAll('[data-header-menu]').forEach((other) => {
        if (other !== menu) other.open = false;
      });
    });
  });

  document.querySelectorAll('[data-review-control]').forEach((button) => {
    button.addEventListener('click', () => {
      const viewport = document.querySelector('[data-review-viewport]');
      if (!viewport) return;
      viewport.scrollBy({ left: Number(button.dataset.reviewControl) * Math.min(viewport.clientWidth * .8, 420), behavior: 'smooth' });
    });
  });
});